import * as React from "react";
import styleable from "react-styleable";
import * as styles from "../../../css/components/mainlayout/nav.css"
import LanguageChoice from "./LanguageChoice"

class Nav extends React.Component<any, any> {
    constructor() {
        super(undefined); // TODO: undefined
        this.state = {
            collapsed: true,
        };
    }

    toggleCollapse() {
        const collapsed = !this.state.collapsed;
        this.setState({collapsed});
    }

    render() {
        // const { location } = this.props;
        // const { collapsed } = this.state;
        // const featuredClass = location.pathname === "/" ? "active" : "";
        // const archivesClass = location.pathname.match(/^\/favorites/) ? "active" : "";
        // const settingsClass = location.pathname.match(/^\/settings/) ? "active" : "";
        // const navClass = collapsed ? "collapse" : "";

        let img: any = "";
        if(this.props.image !== null && this.props.image !== ""){
            img = <img src={this.props.image}/>;
        }

        return (
            <nav className={this.props.css.webctopbar}>
                <div className={"container-fluid " + styles.content}>
                    {img}
                    <h1>{this.props.title}</h1>
                    <h2>{this.props.subtitle}</h2>

                    {typeof this.props.languages !== 'undefined' && this.props.languages !== null && this.props.languages.length > 1 ?
                        (<LanguageChoice languages={this.props.languages} css={{compose: this.props.languageChoiceCss}} i18n={this.props.i18n} />) : ( '' )
                    }
                </div>
            </nav>
        );
    }
}
export default styleable(styles)(Nav)